import H_time from '@/helpers/time';
import H_file from '@/helpers/file';
import i18n from '@/i18n';
import moment from 'moment';
import store from '@/store';
import S_scope from '@/service/api/v1/scope';
import S_license from '@/service/api/v1/license';
import S_internalTraining from '@/service/api/v1/internal_training';
import S_contractorLicense from '@/service/api/v1/contractor_license';
import S_systemClassAnalysis from '@/service/api/v1/systemclass_analysis';
import H_act from '@/helpers/act';
import H_task from '@/helpers/task';
import H_card from '@/helpers/card';
import H_audit from '@/helpers/audit';
import H_guideline from '@/helpers/guideline';
import H_checklist from '@/helpers/checklist';
import H_factoryTag from '@/helpers/factoryTag';
import H_guidelineAdmin from '@/helpers/guidelineAdmin';
import H_guidelineArticleVersionAdmin from '@/helpers/guidelineArticleVersionAdmin';
export default {
  setShow(rawData) {
    const {
      areas,
      area_sections,
      factory_tags,
      last_version,
    } = rawData;
    return {
      ...rawData,
      areas: areas ? areas.map(area => i18n.t(area.name)).join() : '',
      areaSections: area_sections ? area_sections.map(areaSection => i18n.t(areaSection.name)).join() : '',
      factoryTags: H_factoryTag.setShowInModule(factory_tags),
      last_version: this.setVersionData(last_version),
    };
  },
  setVersionData(rawData) {
    return {
      ...rawData,
      attaches: H_file.setTempFileShowInModule(rawData.attaches),
      announceAt: H_time.getDateDashFormat(rawData.announce_at),
      effectAt: rawData.effect_at ? H_time.getDateDashFormat(rawData.effect_at) : '生效日待定',
      taskList: rawData.task
        ? [{
            id: rawData.task.id,
            type: 'task',
            titleSize: 0,
          }]
        : [],
    };
  },
  setChangeReport(rawData) {
    const {
      id,
      last_version: lastVersion,
      area,
      area_section: areaSection,
      act_type: actType,
      industry_categories: industryCategories,
      system_classes: systemClasses,
      system_subclasses: systemSubclasses,
      act_status: actStatus,
      factory_tags: factoryTags,
    } = rawData;
    let resultAct = {
      id,
      area,
      areaSection,
      actType,
      industryCategories,
      systemClasses,
      systemSubclasses,
      actStatus,
      versionId: null,
      actComment: '',
      llComment: '',
      status: '',
      name: '',
      announceAt: '',
      effectAt: '',
      updatedAt: '',
    };
    if (lastVersion) {
      const {
        id: versionId,
        act_comment: actComment,
        ll_comment: llComment,
        status,
        name,
        announce_at: announceAt,
        effect_at: effectAt,
        updated_at: updatedAt,
      } = lastVersion;
      resultAct = {
        ...resultAct,
        versionId,
        actComment,
        llComment,
        status,
        name,
        announceAt: H_time.getDateDashFormat(announceAt),
        effectAt: H_time.getDateDashFormat(effectAt),
        updatedAt: H_time.getDateDashFormat(updatedAt),
        factoryTags: H_factoryTag.setShowInModule(factoryTags),
      }
    }
    return resultAct;
  },
  setIndexData(act, selectIdSet) {
    const {
      id,
      last_version: lastVersion,
      factory_tags,
    } = act;
    return {
      id,
      title: lastVersion ? lastVersion.name : '',
      date: lastVersion ? H_time.getDateDashFormat(lastVersion.announce_at) : '',
      select: selectIdSet.has(id),
      content: this.setActContent(act),
      badges: this.setActDataBadges(act),
      factoryTags: H_factoryTag.setShowInModule(factory_tags),
    };
  },
  setActDataBadges(act) {
    let badges = [];
    if (act.act_status) {
      badges.push(act.act_status.name);
    }
    if (act.last_version) {
      let dateBadge = this.setActUpdateDateBadge(act.last_version.announce_at);
      if (dateBadge) {
        badges.push(dateBadge);
      }
    }
    return badges;
  },
  setActContent(act) {
    let actContent = [];
    let actArea = [];
    if (act.areas && act.areas.length > 0) {
      const areas = act.areas.map(area => i18n.t(area.name)).join();
      actArea.push(areas);
    }
    if (act.area_sections && act.area_sections.length > 0) {
      const areaSections = act.area_sections.map(areaSection => i18n.t(areaSection.name)).join();
      actArea.push(areaSections);
    }
    if (actArea.length === 2) {
      actContent.push(actArea.join('・'));
    } else if (actArea.length === 1) {
      actContent.push(actArea[0]);
    }
    if (act.act_type) {
      actContent.push(i18n.t(act.act_type.name));
    }
    let actStstemClass = act.system_subclasses.map((system) => i18n.t(system.name));
    actContent.push(actStstemClass.join('・'));
    return actContent.join(' | ');
  },
  setActUpdateDateBadge(date) {
    if (!date) return;
    const newDate = moment();
    const secondDate = moment(date);
    const month =
      newDate.diff(secondDate, 'months', true) <= 3
        ? 3
        : newDate.diff(secondDate, 'months', true) <= 6
        ? 6
        : 0;
    if (
      newDate.diff(secondDate, 'months', true) <= month &&
      newDate.diff(secondDate, 'months', true) >= 0
    ) {
      return `${i18n.t('近{number}個月異動', {
        number: month,
      })}`;
    } else {
      return '';
    }
  },
  hasRelatedTemp(rawData) {
    const {has_audit_template, has_checklist_template, has_contractor_license_template, has_internal_training_template, has_license_template} = rawData;
    return has_audit_template || has_checklist_template || has_contractor_license_template || has_internal_training_template || has_license_template;
  },
  hasRelatedDoc(rawData) {
    if (!rawData) return false;
    const {has_audit, has_checklist, has_contractor_license, has_internal_training, has_license, has_guideline_article_version, has_guideline_version, has_guideline_articles, has_guidelines} = rawData;
    return has_audit || has_checklist || has_contractor_license || has_internal_training || has_license || has_guideline_article_version || has_guideline_version || has_guideline_articles || has_guidelines;
  },
  getTemplateCardsData(apiData, type) {
    apiData = S_systemClassAnalysis.userSystemSubclassesAuthCheck(apiData);
    const result = apiData.filter(card => card.last_version);
    return result.map(item => {
      const {id, name, frequency, last_version, related_count, system_subclasses} = item;
      let content = [];
      if (type === 'license') {
        content.push({
          title: '類型',
          text: item.license_type.name,
        });
      }
      if (type === 'checklist') {
        content.push({
          title: '頻率',
          text: i18n.t(frequency),
        });
      }
      content.push(
        {
          title: '更新日期',
          text: H_time.getDateDashFormat(last_version.updated_at),
        },
        {
          title: '引用數量',
          text: related_count,
        }
      );
      return {
        id,
        name,
        system_subclasses,
        content,
        badges: H_card.setTags(item, ['updated']),
        isCardBorderTopHasColor: true,
      };
    });
  },
  getRelatedFieldsList(fullPath, factorySystemClassRows = []) {
    const currentFactoryId = store.state.app.factory.id;
    const relatedModuleFieldsList = [
      {
        title: '證照文件',
        modelName: 'license',
        component: 'LicenseCard',
        to: `/factory/${currentFactoryId}/license-content-main`,
        redirect: fullPath,
        customFunction: (apiData) => S_license.getCardsData(apiData),
        scopeReadable: S_scope.$_isAvailable(['license-read']),
      },
      {
        title: '點檢表文件',
        modelName: 'checklist',
        component: 'LvCard',
        to: `/factory/${currentFactoryId}/checklist-content`,
        redirect: fullPath,
        customFunction: (apiData) => H_checklist.getCard(apiData, factorySystemClassRows),
        scopeReadable: S_scope.$_isAvailable(['checklist-read']),
      },
      {
        title: '稽核表文件',
        modelName: 'audit',
        component: 'LlAuditCard',
        to: `/factory/${currentFactoryId}/audit-content`,
        redirect: fullPath,
        customFunction: (apiData) => H_audit.getCard(apiData, false, factorySystemClassRows),
        scopeReadable: S_scope.$_isAvailable(['audit-read']),
      },
      {
        title: '承攬商資格證文件',
        modelName: 'contractor_license',
        component: 'LicenseCard',
        to: `/factory/${currentFactoryId}/contractor-content`,
        redirect: fullPath,
        customFunction: (apiData) => S_contractorLicense.getCardsData(apiData),
        scopeReadable: S_scope.$_isAvailable(['contractor-read']),
      },
      {
        title: '教育訓練文件',
        modelName: 'internal_training',
        component: 'LicenseCard',
        to: `/factory/${currentFactoryId}/internal-training-content`,
        redirect: fullPath,
        customFunction: (apiData) => S_internalTraining.getCardsData(apiData),
        scopeReadable: S_scope.$_isAvailable(['internal-training-read']),
      },
    ];
    const relatedTemplateFieldsList = [
      {
        title: '證照公版',
        modelName: 'license_template',
        component: 'LicenseCard',
        to: `/factory/${currentFactoryId}/license-template-main`,
        redirect: fullPath,
        customFunction: (apiData) => H_act.getTemplateCardsData(apiData, 'license'),
        scopeReadable: S_scope.$_isAvailable(['license-read']),
      },
      {
        title: '點檢表公版',
        modelName: 'checklist_template',
        component: 'LicenseCard',
        to: `/factory/${currentFactoryId}/checklist-template-content`,
        redirect: fullPath,
        customFunction: (apiData) => H_act.getTemplateCardsData(apiData, 'checklist'),
        scopeReadable: S_scope.$_isAvailable(['checklist-read']),
      },
      {
        title: '稽核表公版',
        modelName: 'audit_template',
        component: 'LicenseCard',
        to: `/factory/${currentFactoryId}/audit-template-content`,
        redirect: fullPath,
        customFunction: (apiData) => H_act.getTemplateCardsData(apiData),
        scopeReadable: S_scope.$_isAvailable(['audit-read']),
      },
      {
        title: '承攬商資格證公版',
        modelName: 'contractor_license_template',
        component: 'LicenseCard',
        to: `/factory/${currentFactoryId}/contractor-license-template-content`,
        redirect: fullPath,
        customFunction: (apiData) => H_act.getTemplateCardsData(apiData),
        scopeReadable: S_scope.$_isAvailable(['contractor-read']),
      },
      {
        title: '教育訓練公版',
        modelName: 'internal_training_template',
        component: 'LicenseCard',
        to: `/factory/${currentFactoryId}/internal-training-template-content`,
        redirect: fullPath,
        customFunction: (apiData) => H_act.getTemplateCardsData(apiData),
        scopeReadable: S_scope.$_isAvailable(['internal-training-read']),
      },
    ];
    const relatedFileFieldsList = [
      {
        fetchUrl: 'file',
        modelName: 'file',
        component: 'LvCard',
        to: `/factory/${currentFactoryId}/file-content`,
        redirect: fullPath,
        customFunction: (rawDataList) => H_file.setCard(rawDataList),
        scopeReadable: true,
      },
    ];
    const relatedGuidelineFieldsListForAct = [
      {
        title: '內規',
        fetchUrl: `factory/${currentFactoryId}/guideline_version/index/act`,
        modelName: 'guidelines',
        component: 'LvCard',
        redirect: fullPath,
        customFunction: (rawDataList) => H_guideline.setCard(rawDataList),
        scopeReadable: S_scope.$_isAvailable(['guideline-read']),
        customPath: (data) => `/factory/${currentFactoryId}/guideline-content/${data.guidelineId}`,
      },
      {
        title: '內規層級條文',
        fetchUrl: `factory/${currentFactoryId}/guideline_article_version/index/act`,
        modelName: 'guideline_articles',
        component: 'LvCard',
        customFunction: (rawDataList) => H_guideline.setCard(rawDataList),
        scopeReadable: S_scope.$_isAvailable(['guideline-read']),
      },
    ];
    const relatedGuidelineFieldsListForGuidelineAdmin = [
      {
        title: '內規',
        fetchUrl: `admin/factory/${currentFactoryId}/guideline`,
        modelName: 'guideline_version',
        component: 'LvCard',
        redirect: fullPath,
        customFunction: (rawDataList) => H_guidelineAdmin.setCard(rawDataList),
        scopeReadable: S_scope.$_isAvailable(['guideline-admin-read']),
      },
      {
        title: '內規層級條文',
        fetchUrl: `admin/factory/${currentFactoryId}/guideline_article_version/index`,
        modelName: 'guideline_article_version',
        component: 'LvCard',
        customFunction: (rawDataList) => H_guidelineArticleVersionAdmin.setCard(rawDataList),
        scopeReadable: S_scope.$_isAvailable(['guideline-admin-read']),
      },
    ];
    const relatedGuidelineFieldsListForGuideline = [
      {
        title: '內規',
        fetchUrl: `factory/${currentFactoryId}/guideline`,
        modelName: 'guideline_version',
        component: 'LvCard',
        redirect: fullPath,
        customFunction: (rawDataList) => H_guidelineAdmin.setCard(rawDataList),
        scopeReadable: S_scope.$_isAvailable(['guideline-read']),
      },
      {
        title: '內規層級條文',
        fetchUrl: `factory/${currentFactoryId}/guideline_article_version/index`,
        modelName: 'guideline_article_version',
        component: 'LvCard',
        customFunction: (rawDataList) => H_guidelineArticleVersionAdmin.setCard(rawDataList),
        scopeReadable: S_scope.$_isAvailable(['guideline-read']),
      },
    ];
    const relatedTaskFieldsList = [
      {
        modelName: 'task',
        component: 'LvCard',
        to: `/factory/${currentFactoryId}/task-content`,
        redirect: fullPath,
        customFunction: (rawDataList) => H_task.setCard(rawDataList),
        scopeReadable: S_scope.$_isAvailable(['task-read']) || S_scope.$_isAvailable(['task-read-all']),
      },
    ];
    return [
      ...relatedModuleFieldsList,
      ...relatedTemplateFieldsList,
      ...relatedFileFieldsList,
      ...relatedGuidelineFieldsListForAct,
      ...relatedGuidelineFieldsListForGuidelineAdmin,
      ...relatedGuidelineFieldsListForGuideline,
      ...relatedTaskFieldsList,
    ];
  },
  hasRelatedModuleSubscribed(relatedType) {
    const baseModuleList = [
      'audit',
      'checklist',
      'contractor',
      'training',
      'license'
    ];
    if (relatedType === 'doc') baseModuleList.push('guideline');
    const factory = store.state.app.factory;
    if (!factory || !factory.subscriptions || factory.subscriptions.length === 0) return false;
    const subscriptionMap = Object.fromEntries(
      factory.subscriptions.map(subscription => [subscription, true])
    );
    return baseModuleList.some(module => subscriptionMap[module]);
  },
};
